var _rect, _g, _rect2, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMountInside21(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "155.9px",
    height: "195px",
    viewBox: "0 0 155.9 195",
    enableBackground: "new 0 0 155.9 195",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: -0.1,
    fill: "#FFFFFF",
    width: 155.9,
    height: 195.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 25.3,
    y: 30,
    fill: "none",
    stroke: "#616261",
    strokeWidth: 1.138,
    strokeMiterlimit: 10,
    width: 106.3,
    height: 147.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 38.7,
    fill: "none",
    stroke: "#616261",
    strokeWidth: 1.138,
    strokeMiterlimit: 10,
    width: 88.8,
    height: 130
  })))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 132.6,
    y: 39.8,
    fill: "#474746",
    width: 0,
    height: 9.9
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#616261",
    strokeWidth: 0.7734,
    strokeMiterlimit: 10,
    d: "M36.1,141.2c0,0-0.4,0.2-0.5,0.7 s-0.1,2.4-0.1,2.4s0,0.6,0.6,0.8c0.6,0.2,4,1,5.1,1.2c1.1,0.3,7.9,2.1,9.7,2.4c1.9,0.3,9.8,1.8,11.4,2c1.6,0.2,13.7,1.5,16.1,1.6 c2.4,0.1,5.3,0,6.9,0c1.6,0,6.9-0.8,10.4-1.1c1.7-0.1,6.3-1,7.3-1.2c0.8-0.2,12.5-3.3,13.1-3.5c0.6-0.2,5.1-1.5,5.4-1.6 c0.3-0.1,0.5-0.2,0.6-0.8c0.1-0.7,0.1-1.9,0.1-1.9s0.1-0.3-0.1-0.4c-0.2-0.1-0.5-0.3-0.5-0.3l-8.8,2.3l-11.4,2.1l-8.8,2l-11.9,0.6 l-17.9-2l-17.3-3.2l-9.2-2.5L36.1,141.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#616261",
    strokeWidth: 0.7734,
    strokeMiterlimit: 10,
    d: "M36.3,137.3c0,0-0.6,0.3-0.7,0.8 c0,0.5,0,2.3,0,2.3s-0.2,0.5,0.4,0.7s4.1,1.4,5.1,1.6c0.9,0.2,10.5,2.3,12.6,2.8c2.1,0.5,14.5,2.4,17.6,2.6s12.3,0.9,12.3,0.9 s8.5-0.6,10.6-0.9c2.1-0.3,9.9-2.1,11.7-2.5c1.9-0.4,12.5-2.9,14-3.3c1.5-0.4,2-0.6,2-0.6s0.5,0,0.5-1.1s0-1.9,0-1.9 s-0.1-0.7-0.6-0.7c-0.5,0-0.5-0.3-0.5-0.3l-5.6,1.5l-16.6,4.1l-11.9,1.8L81,145l-8.2-0.2l-10.3-1.4l-14.1-2.8l-10-3l-1.8-0.5 L36.3,137.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#616261",
    strokeWidth: 0.7734,
    strokeMiterlimit: 10,
    d: "M36.2,133c0,0-0.7,0.3-0.7,1.3 c0,1,0,1.7,0,1.7s-0.2,0.7,0.7,1.1c0.9,0.4,6.1,2.1,7.3,2.5c1.2,0.3,15.3,3.8,18.5,4.2c3.2,0.4,16,1.8,22.8,1.7s14.9-1.8,16.2-1.9 c1.3-0.1,8-2,9.1-2.3c1.1-0.3,10.9-3.2,11.6-3.4c0.7-0.2,0.7-0.3,0.7-1.3c0-1,0.1-1.8-0.3-2.4c-0.4-0.6-0.8-0.7-0.8-0.7l-0.5-0.4 l-18.5,4.6l-9.8,1.8l-10.7,0.5l-9.3-0.9l-12.9-2l-22.9-4.5L36.2,133z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#616261",
    strokeWidth: 0.7734,
    strokeMiterlimit: 10,
    d: "M36,40.5h85.3v80c0,0,1.1,4.3,1.1,6.8 c0,2.5,0,4.2,0,4.2s0.4,1.3-1.7,1.8c-2,0.5-7.9,2.4-12.5,3.4c-6.7,1.5-15.1,3.1-18,3.3c-2.9,0.2-7.8,0.6-13.9,0s-23.5-3.3-26.7-4 c-3.3-0.7-12.3-3-13.2-3.2s-1.5-0.6-1.2-3.4c0.3-2.8,0.8-6,0.8-7.4S36,40.5,36,40.5z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMountInside21);
export default __webpack_public_path__ + "static/media/mount_inside21.002d510ecde26a65d567bc25e47f5567.svg";
export { ForwardRef as ReactComponent };